<template>
  <div
    id="customer-details"
    class="mb-4"
  >
    <div class="col-heading">
      <h3 class="mb-4">
        Enter vehicle details
      </h3>
    </div>

    <div class="form-group col-md-12 col-lg-8 col-xl-6 section__group">
      <form @submit.prevent>
        <div
          class="row"
        >
          <div class="form-group mb-4 col-6">
            <label>
              Vehicle Registration
            </label>
            <span class="input-group">
              <input
                v-model="registration"
                :disabled="disabled || loading"
                :class="{ 'is-invalid': $v.registration.$invalid}"
                class="form-control"
                type="text"
                @keyup.enter="vehicleLookup"
              >
              <span class="input-group-append">
                <button
                  :disabled="$v.registration.$invalid || disabled || loading"
                  type="button"
                  class="btn btn-primary"
                  v-if="this.vehicleRegistrationValidated"
                  @click="vehicleLookup"
                >Verify
                </button>
              </span>
              <small
                v-if="conflict"
                class="error"
              >Vehicle registration is currently overlapping for the selected dates.</small>
            </span>
            <small
              v-if="$v.registration.$invalid && $v.registration.$dirty"
              class="text--error"
            >Please enter a valid registration</small>
          </div>
          <div class="form-group mb-4 col-6 vehicle-details">
            <span v-if="(verifiedVehicle === null || verifiedVehicle.registration === null) && vehicleRegistrationValidated">
              Enter customer's vehicle registration and verify
            </span>
            <ul v-if="verifiedVehicle !== null && verifiedVehicle.registration !== null">
              <label v-if="vehicleLookupSuccess">Vehicle verified</label>
              <label v-if="!vehicleLookupSuccess && vehicleRegistrationValidated">Vehicle not found</label>
              <div class="form-group mb-4 col-12" v-if="this.vehicleMakeHidden === false">
                <label>
                  Make
                </label>
                <input
                  v-model="make"
                  :disabled="vehicleLookupSuccess || disabled || loading"
                  :class="{ 'is-invalid': $v.make.$invalid}"
                  class="form-control"
                >
                <small
                  v-if="$v.make.$invalid && $v.make.$dirty"
                  class="text--error"
                >Please enter a valid make</small>
              </div>
              <div class="form-group mb-4 col-12" v-if="this.vehicleModelHidden === false">
                <label>
                  Model
                </label>
                <input
                  v-model="model"
                  :disabled="vehicleLookupSuccess || disabled || loading"
                  :class="{ 'is-invalid': $v.model.$invalid}"
                  class="form-control"
                >
                <small
                  v-if="$v.model.$invalid && $v.model.$dirty"
                  class="text--error"
                >Please enter a valid model</small>
              </div>
              <div class="form-group mb-4 col-12" v-if="this.vehicleColourHidden === false">
                <label>
                  Colour
                </label>
                <input
                  v-model="colour"
                  :disabled="vehicleLookupSuccess || disabled || loading"
                  :class="{ 'is-invalid': $v.colour.$invalid}"
                  class="form-control"
                >
                <small
                  v-if="$v.colour.$invalid && $v.colour.$dirty"
                  class="text--error"
                >Please enter a valid colour</small>
              </div>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, alphaNum, maxLength, helpers } from 'vuelidate/lib/validators'
const alphaNumericSpacesValidator = helpers.regex('custom', /^[a-zA-Z0-9 ]*$/)
export default {
    name: 'VehicleDetails',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        bookingId: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            loading: false,
            conflict: false
        }
    },
    computed: {
        ...mapState({
            verifiedVehicle: state => state.vehicle.vehicleLookup,
            vehicleLookupSuccess: state => state.vehicle.vehicleLookupSuccess
        }),
        registration: {
            get () {
                return this.$store.state.booking.vehicle.registration
            },
            set (value) {
                this.$store.commit('setVehicleRegistration', value)

                if (! this.vehicleRegistrationValidated) {
                    this.$store.dispatch('setRegistration', value)
                }

                this.$v.make.$touch()
                this.validateForm()
            }
        },
        make: {
            get () {
                return this.$store.state.vehicle.vehicleLookup.make
            },
            set (value) {
                this.$store.commit('setMake', value)
                this.$v.make.$touch()
                this.validateForm()
            }
        },
        model: {
            get () {
                return this.$store.state.vehicle.vehicleLookup.model
            },
            set (value) {
                this.$store.commit('setModel', value)
                this.$v.model.$touch()
                this.validateForm()
            }
        },
        colour: {
            get () {
                return this.$store.state.vehicle.vehicleLookup.colour
            },
            set (value) {
                this.$store.commit('setColour', value)
                this.$v.colour.$touch()
                this.validateForm()
            }
        },
        vehicleMakeHidden () {
            var airportConfig = this.$store.getters['getSpecificConfiguration']({
                section: 'AirportConfigurations',
                identifier: this.$store.getters['getSelectedAirport'].id
            })
            if (airportConfig) {
                return airportConfig.hideVehicleMakeField
            }
            return false
        },
        vehicleModelHidden () {
            var airportConfig = this.$store.getters['getSpecificConfiguration']({
                section: 'AirportConfigurations',
                identifier: this.$store.getters['getSelectedAirport'].id
            })
            if (airportConfig) {
                return airportConfig.hideVehicleModelField
            }
            return false
        },
        vehicleColourHidden () {
            var airportConfig = this.$store.getters['getSpecificConfiguration']({
                section: 'AirportConfigurations',
                identifier: this.$store.getters['getSelectedAirport'].id
            })
            if (airportConfig) {
                return airportConfig.hideVehicleColourField
            }
            return false
        },
        vehicleRegistrationValidatedvehicleRegistrationValidated () {
            var feature = this.$store.getters['feature/getFeatureActiveByName']("VehicleRegistrationVerificationDisabled")
            var result = feature !== true;

            if (this.vehicleMakeHidden && this.vehicleModelHidden && this.vehicleColourHidden) {
                result = false;
            }

            return result
        }
    },
    validations () {

        let config = {
            registration: {
                required,
                alphaNumericSpacesValidator,
                maxLength: maxLength(10)
            },
            make: {
                maxLength: maxLength(50)
            },
            model: {
                maxLength: maxLength(80)
            },
            colour: {
                maxLength: maxLength(20)
            }};

        if (this.vehicleMakeHidden === false) {
            config.make['required'] = required;
        }

        if (this.vehicleModelHidden === false) {
            config.model['required'] = required;
        }

        if (this.vehicleColourHidden === false) {
            config.colour['required'] = required;
        }

        return config;
    },
    mounted () {
        if (this.$store.state.feature.features.length === 0) {
            this.$store.dispatch('feature/setFeatures')
        }

        this.$v.$touch()
        this.validateForm()
    },
    methods: {
        async vehicleLookup () {
            if (!this.$v.registration.$invalid && !this.disabled && !this.loading) {
                let reg = this.$store.state.booking.vehicle.registration
                this.loading = true
                this.conflict = false
                var result = await this.$store.dispatch('vehicleLookup', [this.$store.state.booking.vehicle.registration, true])
                if (result.status === 200 && result.data !== null && result.data.registration !== null) {
                    const vehicleCheckResult = await this.$store.dispatch('updateVehicle', [this.bookingId, result.data])
                    if (vehicleCheckResult.status === 409) {
                        this.$store.dispatch('resetVehicle')
                        this.conflict = true
                    } else if (vehicleCheckResult.status !== 200 && vehicleCheckResult.status !== 201) {
                        this.$toasted.error(`${vehicleCheckResult.data}`)
                    } else {
                        this.$store.dispatch('setLookupSuccess', true)
                    }
                } else if (result.status === 200 && result.data !== null && result.data.registration === null) {
                    this.$store.dispatch('setRegistration', reg)
                    this.$store.dispatch('setLookupSuccess', false)
                }
                this.loading = false
            }
        },
        validateForm () {
            this.$store.commit('setVehicleInfoValid', !this.$v.$invalid)
        }
    }
}
</script>
